// get extension from file name
export const getExtensionFromFilename = (filename: string): string => {
    return String(filename).split('.').pop().toLowerCase();
}